import React from 'react';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import { Link as RouterLink } from 'react-router-dom';
import {
  RELEASE_STATE_LABELS,
  RELEASE_STATE_MESSAGES,
  shouldShowReleaseStateNotice,
} from './releaseState';
import { ROUTES } from './routes';

export default function GlobalReleaseBanner({ releaseState }) {
  if (!shouldShowReleaseStateNotice(releaseState)) {
    return null;
  }

  return (
    <Box
      data-testid="global-release-banner"
      sx={{
        bgcolor: 'warning.light',
        borderBottom: 1,
        borderColor: 'warning.main',
      }}
    >
      <Alert
        severity="warning"
        icon={false}
        square
        sx={{
          maxWidth: 1200,
          mx: 'auto',
          py: { xs: 0.75, sm: 1 },
          px: { xs: 1.5, sm: 2 },
          bgcolor: 'transparent',
          color: 'warning.contrastText',
          alignItems: 'center',
          '& .MuiAlert-message': {
            width: '100%',
            py: 0,
          },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { xs: 'flex-start', sm: 'center' },
            gap: { xs: 0.25, sm: 1 },
          }}
        >
          <AlertTitle
            component="span"
            sx={{
              m: 0,
              fontSize: '0.875rem',
              fontWeight: 900,
              lineHeight: 1.4,
              color: 'inherit',
            }}
          >
            Early Access
          </AlertTitle>
          <Box component="span" sx={{ fontSize: '0.875rem', lineHeight: 1.4 }}>
            {RELEASE_STATE_MESSAGES.globalBanner}{' '}
            <Link
              component={RouterLink}
              to={ROUTES.earlyAccess}
              data-testid="global-release-banner-learn-more"
              sx={{ color: 'inherit', fontWeight: 800, textDecorationColor: 'currentColor' }}
            >
              {RELEASE_STATE_LABELS.learnMore}
            </Link>
          </Box>
        </Box>
      </Alert>
    </Box>
  );
}
